import { CommonGet, CommonPost } from "../../../utils/CommonFetch";


export default {
    
    getAll,
    editData,
    getGroupsForDropdown,
    getAllOperationEntitiesForDropDown,
    UpdateTag,
    getTagDetails,
    RemoveTag,
    getDeductionTypes,
    getCustomersFromCollectionPoint,
    getDeductionTypesByGroupEntityID,
    saveToApproval,
    getFactoryTagDetails,
    saveToFactoryApproval,
    getDeductionTemplate
};



async function UpdateTag(data){
    const response = await CommonPost('/api/ProductCollection/UpdateTagDetails', null, data);
    return response;
}


async function RemoveTag(data){
    const response = await CommonPost('/api/ProductCollection/RemoveTag', null, data);
    return response;
}

async function getAll(){
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function editData(data) {
    data.groupName = data.groupName.trim();
    data.modifiedDate = new Date().toISOString()
    const response = await CommonPost('/api/Group/UpdateGroup', null, data);
    return response;
}

async function getGroupsForDropdown() {
    var groupArray = [];
    
    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if(item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }

    return groupArray;
}

async function getAllOperationEntitiesForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetOperationEntityByGroupIDEntityID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
        operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}

async function getTagDetails(data) {
    let form = {
        groupID: parseInt(data.groupID),
        operationEntityID: parseInt(data.operationEntityID),
        tagNo: data.tag,
        date: data.date
      }
      const response = await CommonPost('/api/ProductCollection/GetTagDetails', null, form);
     
      return response.data;
}
async function getCustomersFromCollectionPoint(collectionPoint){
   
     const response = await CommonGet('/api/Customer/GetAllCustomerbyCollectionPointID', 'collectionPointID=' + collectionPoint)
   
     return response.data;
 }
 

 async function getDeductionTypesByGroupEntityID(groupID, entityID) {
    const response = await CommonGet('/api/DeductionType/GetDeductionTypesByGroupIDEntityID', 'groupID=' + groupID + '&entityID=' + entityID)
 
    let array = []
    for (let item of Object.entries(response.data)) {
        array[item[1]["deductionTypeID"]] = item[1]["deductionTypeName"]
    }
    return array;
}
async function getDeductionTypes() {
    var response = await CommonGet('/api/DeductionType/GetAllDeductionTypes', null);
  
    return response.data;

}

async function saveToApproval(data){
    const response = await CommonPost('/api/TagAmendment/SaveTagAmendRequest', null, data);
    
    return response;
}


async function getFactoryTagDetails(data) {
    let form = {
        groupID: parseInt(data.groupID),
        operationEntityID: parseInt(data.operationEntityID),
        tagNo: data.tag,
        date: data.date
      }
      const response = await CommonPost('/api/TagAmendment/GetFactoryWeighDetailsByTag', null, form);
    
      return response.data;
}

async function saveToFactoryApproval(data){
    const response = await CommonPost('/api/TagAmendment/SaveFactoryTagAmendRequest', null, data);
   
    return response;
}



async function getDeductionTemplate(groupID,entityId,collectionPointID){
    const response = await CommonGet('/api/DeductionTemplate/GetAllDeductionTemplates', 'groupID=' + groupID + '&operationEntityId=' + entityId + '&collectionPointID=' + collectionPointID);
   
    return response.data;
}